import { useEffect, useMemo, useState } from 'react';
//Router dom
import { Link } from 'react-router-dom';

import './Branches.css'

import BranchList from './BranchList';
import EditBranch from './EditBranch/EditBranch';
import BranchItemMenu from './components/BranchItemMenu';

import { branchList } from '../../../actions/admin/branch';

//MUI
import {
    Container, Fab, Typography, Snackbar, IconButton,
    Backdrop, CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

import { BRANCH_EDIT } from '../../../constants/admin/branch_constants';

const Branches = () => {
    // bandera de carga de sucursales
    const [initialLoading, setInitialLoading] = useState(true);
    // bandera para backdrop en eliminación
    const [loading, setLoading] = useState(false);

    const [branches, setBranches] = useState([]); // lista original
    // lista de sucursales para ordenamiento
    const [orderedBranches, setOrderedBranches] = useState([]);

    // edición de sucursal
    const [activeBranch, setActiveBranch] = useState(BRANCH_EDIT);

    const [snackbarData, setSnackbarData] = useState({
        open: false, message: ''
    });
    const { open, message } = snackbarData;

    //Menu opciones
    const [anchorEl, setAnchorEl] = useState(null);

    //Modal para editar
    const [openModal, setOpenModal] = useState(false);
    const handleClickModal = () => {
        setOpenModal(true);
        setAnchorEl(null);
    };
    
    useEffect(() => {
        getBranchList();
    }, []);

    useEffect(() => {
        if (!initialLoading)
            setOrderedBranches(branches);
    }, [initialLoading, branches]);

    // evalúa si ha habido cambios de posición en la lista
    const compareArrays = (original, editado) => {
        // la longitud no es la misma
        if (original.length !== editado.length) return true;

        // junta los ID en cadena y compara
        const originalString = original.map(item => `${item._id}`).join('|');
        const editedString = editado.map(item => `${item._id}`).join('|');
        return originalString !== editedString;
    };

    // cargar lista de sucursales
    const getBranchList = async () => {
        await branchList(setBranches, setSnackbarData);
        setInitialLoading(false);
    };

    const handleClose = () => setSnackbarData(e => ({ ...e, open: false }));

    const action = (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={ handleClose }>
            <CloseIcon fontSize="small" />
        </IconButton>
    );

    // mostrar botón para actualizar orden de lista
    const showUpdateButton = useMemo(() => {
        return compareArrays(branches, orderedBranches);
    }, [branches, orderedBranches]);

    return (
        <>
            <Container maxWidth='xl' sx={{ mb: 5 }} style={{ marginTop: '90px' }}>
                <Typography variant='h5' paragraph>Lista de sucursales</Typography>
                <BranchList
                    initialLoading={initialLoading}
                    branches={branches}
                    orderedBranches={orderedBranches}
                    setOrderedBranches={setOrderedBranches}
                    setAnchorEl={setAnchorEl}
                    setActiveBranch={setActiveBranch}
                />
            </Container>

            {/* Menu */}
            <BranchItemMenu
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                activeBranch={activeBranch}
                setActiveBranch={setActiveBranch}
                setBranches={setBranches}
                setLoading={setLoading}
                setSnackbarData={setSnackbarData}
                handleClickModal={handleClickModal}
            />

            {
                showUpdateButton &&
                    <Fab
                        LinkComponent={Link}
                        to='/nefro-admin/nueva-sucursal'
                        color="secondary"
                        sx={{
                            position: "fixed",
                            bottom: '105px',
                            right: '35px',
                            '&:hover': {
                                color: '#fff',
                            }
                        }}
                    >
                        <SaveIcon />
                    </Fab>
            }

            <Fab
                LinkComponent={Link}
                to='/nefro-admin/nueva-sucursal'
                color="primary"
                sx={{
                    position: "fixed",
                    bottom: '35px',
                    right: '35px',
                    '&:hover': {
                        color: '#fff',
                    }
                }}
            >
                <AddIcon />
            </Fab>

            <Snackbar
                open={open}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={6000}
                onClose={handleClose}
                message={message}
                action={action}
            />

            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={ () => setLoading(false) }
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        
            <EditBranch
                openModal={ openModal }
                setOpenModal={ setOpenModal }
                activeBranch={ activeBranch }
                setActiveBranch={ setActiveBranch }
                setBranches={ setBranches }
                setSnackbarData={setSnackbarData}
            />
        </>
    );
};
    
export default Branches;